/* Mr Football - size finder. Two modes, chosen from the product's own sizes.

   ADULT (S..4XL) - height + weight.
   S-XXL bands are the store's published guide (sizeguide_mr_football.jpg).
   3XL and 4XL are EXTRAPOLATED from the S-XXL progression, are not measured,
   and say so in the UI.

   KIDS (2-4 .. 14-15) - height only, and deliberately so.
   The store's kids chart carries age, length and chest but NO height and NO
   weight, so nothing can be derived from it directly. Several bands below are
   taken from the store's own KIDS TRACKSUIT chart, which does publish height
   for the same supplier and the same age labels:
       7-8    115-125 cm   (measured)
       9      125-135 cm   (measured)
       10-11  135-145 cm   (measured)
       12-13  145-155 cm   (measured)
       14-15  155-160 cm   (measured)
   The remaining bands (2-4, 5-6, 9-10, 11-12, 13-14) are interpolated on the
   same ~10cm cadence and cross-checked against typical height-for-age. They
   are marked `derived`. Replace them with real supplier numbers when you have
   them.

   Weight is not asked for children: kidswear is sized by height almost
   everywhere, and a child's weight adds noise rather than signal.

   WHY IT ALWAYS OFFERS NEIGHBOURS
   On the ANSUR II set (n=4,082 men) height and weight explain 86% of chest
   variance but leave +/-6.3cm at 95% - about one full size. One size is right
   ~69% of the time; the two adjacent sizes cover 99.8%.

   NOTE ON APOSTROPHES: this file is written through a GraphQL block string,
   which does NOT process backslash escapes. A \\' inside a JS string literal
   therefore arrives as a literal backslash and breaks the parse. Use the
   typographic apostrophe instead. */
(function () {
  'use strict';

  var ADULT = [
    { key: 'S',   h: [160, 173], w: [50, 65],  chest: 50, length: 71 },
    { key: 'M',   h: [173, 179], w: [56, 70],  chest: 53, length: 74 },
    { key: 'L',   h: [179, 183], w: [62, 78],  chest: 55, length: 77 },
    { key: 'XL',  h: [183, 186], w: [68, 85],  chest: 58, length: 80 },
    { key: 'XXL', h: [186, 190], w: [75, 90],  chest: 60, length: 83 },
    { key: '3XL', h: [190, 196], w: [82, 98],  chest: 63, length: 86, estimated: true },
    { key: '4XL', h: [196, 202], w: [90, 108], chest: 65, length: 89, estimated: true }
  ];

  var KIDS = [
    { key: '2-4',   h: [92, 104],  length: 44, chest: 35, derived: true },
    { key: '4-5',   h: [100, 110], length: 47, chest: 37, derived: true },
    { key: '5-6',   h: [105, 116], length: 50, chest: 39, derived: true },
    { key: '7-8',   h: [115, 125], length: 53, chest: 41 },
    { key: '9',     h: [125, 135], length: 56, chest: 43 },
    { key: '9-10',  h: [125, 138], length: 56, chest: 43, derived: true },
    { key: '10-11', h: [135, 145], length: 59, chest: 45 },
    { key: '11-12', h: [138, 150], length: 59, chest: 45, derived: true },
    { key: '12-13', h: [145, 155], length: 62, chest: 47 },
    { key: '13-14', h: [150, 163], length: 62, chest: 47, derived: true },
    { key: '14-15', h: [155, 160], length: 65, chest: 48 }
  ];

  var ALIASES = {
    S: ['s', 'small'],
    M: ['m', 'medium'],
    L: ['l', 'large'],
    XL: ['xl', 'x-large', 'extra large'],
    XXL: ['xxl', '2xl', 'xx-large'],
    '3XL': ['3xl', 'xxxl'],
    '4XL': ['4xl', 'xxxxl']
  };

  var STORE_KEY = 'mf_size_finder';

  function canonAdult(raw) {
    var v = String(raw || '').trim().toLowerCase();
    for (var key in ALIASES) {
      if (ALIASES[key].indexOf(v) !== -1) return key;
    }
    return null;
  }

  function canonKids(raw) {
    var v = String(raw || '').trim().toLowerCase().replace(/\s|years?|yrs?|y/g, '').replace(/[–—]/g, '-');
    for (var i = 0; i < KIDS.length; i++) {
      if (KIDS[i].key === v) return KIDS[i].key;
    }
    return null;
  }

  function miss(value, range) {
    if (value < range[0]) return range[0] - value;
    if (value > range[1]) return value - range[1];
    return 0;
  }

  function esc(s) {
    return String(s).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }

  function init(root) {
    if (root.dataset.mfSizeReady) return;
    root.dataset.mfSizeReady = '1';

    var kids = root.dataset.mfMode === 'kids';
    var TABLE = kids ? KIDS : ADULT;
    var canon = kids ? canonKids : canonAdult;

    var heightEl = root.querySelector('[data-mf-size-height]');
    var weightEl = root.querySelector('[data-mf-size-weight]');
    var weightWrap = root.querySelector('[data-mf-weight-wrap]');
    var goEl = root.querySelector('[data-mf-size-go]');
    var outEl = root.querySelector('[data-mf-size-result]');
    var unitEls = root.querySelectorAll('[data-mf-size-unit]');
    if (!heightEl || !goEl || !outEl) return;

    if (kids && weightWrap) {
      weightWrap.parentNode.removeChild(weightWrap);
      weightEl = null;
    }

    var available = (root.dataset.mfSizes || '')
      .split('|')
      .map(canon)
      .filter(function (v, i, a) { return v && a.indexOf(v) === i; });

    var pool = TABLE.filter(function (s) {
      return !available.length || available.indexOf(s.key) !== -1;
    });
    if (!pool.length) pool = TABLE.slice();

    var unit = 'metric';

    function setUnit(next) {
      unit = next;
      Array.prototype.forEach.call(unitEls, function (el) {
        var on = el.dataset.mfSizeUnit === unit;
        el.setAttribute('aria-pressed', String(on));
        el.classList.toggle('is-active', on);
      });
      root.querySelector('[data-mf-label-height]').textContent =
        unit === 'metric' ? 'Height (cm)' : 'Height (inches)';
      var wl = root.querySelector('[data-mf-label-weight]');
      if (wl) wl.textContent = unit === 'metric' ? 'Weight (kg)' : 'Weight (lb)';
      heightEl.placeholder = unit === 'metric' ? (kids ? '128' : '178') : (kids ? '50' : '70');
      if (weightEl) weightEl.placeholder = unit === 'metric' ? '74' : '163';
      heightEl.value = '';
      if (weightEl) weightEl.value = '';
      outEl.hidden = true;
    }

    Array.prototype.forEach.call(unitEls, function (el) {
      el.addEventListener('click', function () { setUnit(el.dataset.mfSizeUnit); });
    });

    function selectSwatch(key) {
      var scope = root.closest('.product-single__meta') || document;
      var wanted = kids ? [key.toLowerCase()] : (ALIASES[key] || []);
      var nodes = scope.querySelectorAll('.js-variant-selector input, .js-variant-selector label, .swatches__container input, .swatches__container label');
      for (var i = 0; i < nodes.length; i++) {
        var n = nodes[i];
        var v = (n.value || n.textContent || '').trim().toLowerCase();
        if (wanted.indexOf(v) !== -1) { n.click(); return true; }
      }
      return false;
    }

    function render(baseIdx, chosenIdx) {
      var chosen = pool[chosenIdx];
      var html = '';

      html += '<p class="mf-size__answer">We would go for <strong>' + esc(chosen.key) + '</strong>' +
        (kids ? ' <span class="mf-size__unitlbl">years</span>' : '') + '</p>';

      html += '<div class="mf-size__opts" role="group" aria-label="Fit preference">';
      [
        { label: kids ? 'Smaller' : 'Fitted', idx: baseIdx - 1 },
        { label: 'Ideal', idx: baseIdx },
        { label: kids ? 'Room to grow' : 'Looser', idx: baseIdx + 1 }
      ].forEach(function (o) {
        if (o.idx < 0 || o.idx >= pool.length) return;
        var on = o.idx === chosenIdx;
        html += '<button type="button" class="mf-size__opt' + (on ? ' is-active' : '') +
          '" data-mf-opt="' + o.idx + '" aria-pressed="' + on + '">' +
          '<span class="mf-size__opt-l">' + o.label + '</span>' +
          '<span class="mf-size__opt-s">' + esc(pool[o.idx].key) + '</span></button>';
      });
      html += '</div>';

      html += '<p class="mf-size__detail">Chest ' + chosen.chest + 'cm &middot; length ' + chosen.length + 'cm';
      html += ' &middot; made for ' + chosen.h[0] + '-' + chosen.h[1] + 'cm';
      if (!kids) html += ', ' + chosen.w[0] + '-' + chosen.w[1] + 'kg';
      html += '.</p>';

      if (chosen.estimated) {
        html += '<p class="mf-size__note">' + esc(chosen.key) + ' is not on our measured chart yet, so treat it as an estimate.</p>';
      }

      if (kids) {
        html += '<p class="mf-size__note">Kits are labelled by age, but height is the better guide. Between sizes? Go up — they grow.</p>';
      } else {
        html += '<p class="mf-size__note">Height and weight cannot tell us your shoulder width. If you are broad across the shoulders, take the looser one.</p>';
      }

      html += '<button type="button" class="button mf-size__pick" data-mf-size-pick>Select ' + esc(chosen.key) + '</button>';

      outEl.hidden = false;
      outEl.innerHTML = html;

      Array.prototype.forEach.call(outEl.querySelectorAll('[data-mf-opt]'), function (b) {
        b.addEventListener('click', function () {
          render(baseIdx, parseInt(b.dataset.mfOpt, 10));
        });
      });

      var pick = outEl.querySelector('[data-mf-size-pick]');
      pick.addEventListener('click', function () {
        var ok = selectSwatch(chosen.key);
        pick.textContent = ok ? chosen.key + ' selected' : 'Pick ' + chosen.key + ' above';
        pick.disabled = true;
      });
    }

    function run() {
      var hRaw = parseFloat(heightEl.value);
      var wRaw = weightEl ? parseFloat(weightEl.value) : null;

      if (!hRaw || (!kids && !wRaw)) {
        outEl.hidden = false;
        outEl.innerHTML = '<p class="mf-size__msg">' +
          (kids ? 'Enter the child’s height.' : 'Enter both your height and your weight.') + '</p>';
        return;
      }

      var h = unit === 'metric' ? hRaw : hRaw * 2.54;
      var w = wRaw ? (unit === 'metric' ? wRaw : wRaw * 0.45359) : null;

      var lo = kids ? 80 : 120, hi = kids ? 180 : 220;
      if (h < lo || h > hi || (w !== null && (w < 25 || w > 200))) {
        outEl.hidden = false;
        outEl.innerHTML = '<p class="mf-size__msg">That is outside the range we can advise on. Message us and we will sort it.</p>';
        return;
      }

      var best = 0, bestScore = Infinity;
      for (var i = 0; i < pool.length; i++) {
        var s = pool[i];
        var sc = kids ? miss(h, s.h) : (miss(w, s.w) + miss(h, s.h) * 0.25);
        var mid = kids ? (s.h[0] + s.h[1]) / 2 : (s.w[0] + s.w[1]) / 2;
        var tie = Math.abs((kids ? h : w) - mid) * 0.01;
        if (sc + tie < bestScore) { bestScore = sc + tie; best = i; }
      }

      render(best, best);

      try {
        localStorage.setItem(STORE_KEY, JSON.stringify({ h: hRaw, w: wRaw, unit: unit, kids: kids }));
      } catch (e) { /* private mode */ }
    }

    goEl.addEventListener('click', run);
    root.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' && (e.target === heightEl || e.target === weightEl)) {
        e.preventDefault();
        run();
      }
    });

    setUnit('metric');

    try {
      var saved = JSON.parse(localStorage.getItem(STORE_KEY) || 'null');
      if (saved && saved.kids === kids && saved.h) {
        setUnit(saved.unit === 'imperial' ? 'imperial' : 'metric');
        heightEl.value = saved.h;
        if (weightEl && saved.w) weightEl.value = saved.w;
      }
    } catch (e) { /* ignore */ }
  }

  function boot() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-mf-size-finder]'), init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();